export var getHasObjectProperty = function getHasObjectProperty(options, property) {
  return !!options && options.some(function (option) {
    return option.hasOwnProperty(property);
  });
};